import { createStyles, Theme, Tooltip, withStyles } from "@material-ui/core";
import { TooltipProps } from "@material-ui/core/Tooltip";
import * as React from "react";
import { yellow } from "@material-ui/core/colors";

const styles = (theme: Theme) => createStyles({
  tooltip: {
    backgroundColor: yellow[200],
    boxShadow: theme.shadows[1],
    color: theme.palette.getContrastText(yellow[200])
  }
});

class ColorTooltip extends React.Component<TooltipProps> {

  public render() {

    return <Tooltip {...this.props}></Tooltip>;
  }

}

export default withStyles(styles, {withTheme: true})(ColorTooltip);
